/* eslint-disable */

export const SET_ERROR = (state, error) => {
  state.error = error;
};

export const SET_CAMPAIGN = (state, payload) => {
  if (payload.status === undefined) {
    state.campaign = payload.campaign;
    if (state.order.campaign.id === undefined) {
      state.order.campaign = {...payload.campaign};
      state.order.quantity = payload.campaign.quantity_default;
    }
    // make the selected property reactive
    state.campaign.offers.forEach((offer) => {
      if (state.order.offers.filter(x => x.id === offer.id).length) {
        offer.selected = true;
      } else {
        offer.selected = false;
      }
    });
    if (payload.customer) {
      state.order.customer = payload.customer;
      state.order.customer.anonymous = false;
    }
  }
};

export const SET_CODES = (state, params) => {
  state.order.campaign.url_code = params.campaign;
  state.order.customer.url_code = params.customer;
};

export const SELECT_OFFER = (state, offer) => {
  state.order.offers.push(offer);
};

export const REMOVE_OFFER = (state, offer) => {
  state.order.offers = state.order.offers.filter(x => x.id !== offer.id);
};

export const UPDATE_ORDER = (state, order) => {
  state.order = { ...state.order, ...order };
};

export const RESET_OFFERS = (state) => {
  state.order.offers = [];
};

export const SET_ORDER_LOADING = (state, loading) => {
  state.order.loading = !!loading;
};
